import { render, staticRenderFns } from "./PaymentHead.vue?vue&type=template&id=923bf4ce&scoped=true&"
import script from "./PaymentHead.vue?vue&type=script&lang=ts&"
export * from "./PaymentHead.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentHead.vue?vue&type=style&index=0&id=923bf4ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923bf4ce",
  null
  
)

export default component.exports